/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export class ProcessFileDownload implements IDirective {
        public controller = ["$scope", "fileUploadDownloadService", "documentService", ProcessFileDownloadController];
        public controllerAs = "controller";
        public templateUrl = "./app/views/directives/processFileDownload.html";
        public restrict: string = "E";

        public scope: any = {
            model: "=",
            process: "=",
            linkOnly: "=",
            iconOnly: "="
        };

        public link(scope: IProcessFileDownloadScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: ProcessFileDownloadController): void { }
    }

    export interface IProcessFileDownloadScope extends ng.IScope {
        model: Wars.Domain.Model.Dtos.DocumentDto;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        linkOnly: boolean;
        iconOnly: boolean;
        getFaClass(filename: string): string;
        downloadSecureDocument(): void;
    }

    export class ProcessFileDownloadController implements IController {
        constructor(
            private $scope: IProcessFileDownloadScope,
            private fileUploadDownloadService: services.FileUploadDownloadService,
            private documentService: services.DocumentService)
        {
            this.$scope.getFaClass = (filename: string) => this.documentService.getFaClass(filename);
            this.$scope.downloadSecureDocument = () => this.downloadSecureDocument();
        }

       public downloadSecureDocument(): void {
           this.fileUploadDownloadService.getSecuredDocumentKey(this.$scope.model.id).then((securedDocKey) => {
               var url = "./api/document/Secured/" + securedDocKey;
               window.open(url);
           });
       }
    }
}

warsApp.registerDirective('ProcessFileDownload', []);